import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import { IAppointmentModel } from 'models/Appointment.Model';
import { IAppointmentSlotModel } from 'models/AppointmentSlot.Model';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, } from 'react-router-dom';
import CommonService from 'services/CommonService';
import { ID_EncryptionKey, isMobile } from '../../helpers/Helper';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { CustomButton } from 'components/shared/CustomButton';

var CryptoJS = require("crypto-js");

function Reschedule() {
    document.title = "Re-Schedule | DOFY-Admin";

    const { encryptedId } = useParams<any>();
    let locator = useLocation();

    //For AES Decryption
    // let wordArrays = CryptoJS.enc.Hex.parse(encryptedId)
    // let base64String = CryptoJS.enc.Base64.stringify(wordArrays)
    // var bytes = CryptoJS.AES.decrypt(base64String, ID_EncryptionKey, { keySize: 128, iv: ID_EncryptionKey, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    // var decryptedId = bytes.toString(CryptoJS.enc.Utf8);

    const navigate = useNavigate();

    let urlData = locator.pathname;
    let isReschedule = urlData.startsWith("/re-schedule") ? true : false;

    const [slotDate, setSlotDate] = useState<Date>();
    const [slotSession, setSlotSession] = useState({ StartTime: "", EndTime: "", Id: 0 });
    const [slotList, setSlotList] = useState<Array<IAppointmentSlotModel>>([])
    const IsMobile = useTypedSelector(state => state.FindDevice.isMobile);
    const [isButton, SetisButton] = useState<boolean>(false);
    const [orderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>();
    const currentDate = new Date();

    const slotHandler = () => {
        let appointmentData: IAppointmentModel = {
            Id: 0,
            Created: "2022-04-13T14:40:43.424Z",
            CreatedBy: 0,
            Active: true,
            Modified: "2022-04-13T14:40:43.424Z",
            ModifiedBy: 0,
            ValidationErrors: {},
            OrderId: 0,
            AssigneeId: null,
            UserAddresId: orderSummaryInfo?.Appointment.UserAddresId,
            AppointmentDate: slotDate,
            StartTime: slotSession.StartTime,
            EndTime: slotSession.EndTime,
            Remarks: "",
            TechnicianComments: "",
            RowOrder: 0,
            IsReschedule: true,
            AppointmentCity: "",
            AppointmentPincode: 0,
            address: ""
        };
        if (!isReschedule) {
            CommonService.post("Sell", "CreateAppointment", appointmentData).then(res => {
                if (res.status === 200) {
                    CommonService.postWithSingleParam("sell", "RetrieveOrder", encryptedId).then((response: any) => {
                        if (response.status === 200) {
                            window.location.href = (`/agent-ticket-view/${encryptedId}`);
                        }
                    }).catch(exception => console.log(exception));
                }
            }).catch((e: string) => {
                console.log(e)
            });
        }
        else {
            appointmentData.EncryptedId = orderSummaryInfo?.EncryptedId;
            CommonService.post("Sell", "AdminReschedule", appointmentData).then(res => {
                if (res.status === 200) {
                    SetisButton(true);
                    window.location.href = (`/agent-ticket-view/${encryptedId}`);

                }
            }).catch((e: string) => {
                console.log(e)
            });
        }
        SetisButton(true);
    }


    useEffect(() => {
        const getOrderSummaryById = () => {
            CommonService.getWithSingleEntity('sell', 'GetOrderSummary', encryptedId).then(res => {
                if (res.status === 200) {
                    let order = res.data as IGetOrderSummaryModel;
                    setOrderSummaryInfo(order);
                    getAppointmentSlotList(res.data.ProductTypeId, res.data.ServiceTypeId, false, order.Appointment?.UserAddresId);
                }
            }).catch(e => {
                console.log(e);
            })
        }

        const getAppointmentSlotList = (productTypeId: number, serviceTypeId: number, isExpressPickup: boolean, userAddresId: number) => {
            CommonService.postWithPentaParams("Appointmentslots", "GetAppointmentSlots", 'date', moment(currentDate).format('yyyy-MM-DD HH:mm'), 'productTypeId', productTypeId, 'serviceTypeId', serviceTypeId, 'isExpressPickup', isExpressPickup, 'userAddressId', userAddresId).then(res => {
                if (res.status === 200) {
                    setSlotList(res.data);
                }
            }).catch(e => {
                console.log(e);
            });
        }
        getOrderSummaryById()
    }, [encryptedId])


    const GetTimeSlots = (slotLists: Array<IAppointmentSlotModel>) => {
        return (
            <>
                <div className='text-dofy fw-semibold'>
                    <p>Please select your preferable pickup date</p>
                </div>
                <div className="time-grid">
                    {slotLists.filter((value, index, self) => index === self.findIndex((t) => (t.EventDate === value.EventDate)))
                        .map((val, i) => (
                            <>
                                {moment(val.EventDate).format("MMM Do YY") === moment(currentDate).format("MMM Do YY") ?
                                    <div className={`${slotDate == val.EventDate ? 'time-box-active' : 'time-box'} cursor-pointer`} onClick={() => setSlotDate(val.EventDate)}>
                                        <div className='text-center'>
                                            <p className="fw-semibold m-0 font-size-13">
                                                Express Pickup
                                            </p>

                                        </div>
                                    </div>
                                    :
                                    <div className={`${slotDate == val.EventDate ? 'time-box-active' : 'time-box'} cursor-pointer`} onClick={() => setSlotDate(val.EventDate)}>
                                        <div className='text-center'>
                                            <p className="fw-semibold m-0 font-size-14">
                                                {moment(val.EventDate).format("ddd")}
                                            </p>
                                            <p className="fw-bolder m-0 font-size-16" style={{ marginTop: '-3px' }}>
                                                {moment(val.EventDate).format('D')?.toString().padStart(2, "0")}
                                            </p>
                                        </div>
                                    </div>}
                            </>

                        ))}
                </div>
            </>
        )
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container >
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>RE-SCHEDULE TIMESLOTS</h5>
                    </div>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col xl={6} lg={6} md={6} sm={12} xs={12} className=''>
                                    {GetTimeSlots(slotList)}
                                </Col>
                                <Col xl={6} lg={6} md={6} sm={12} xs={12} className=''>
                                    {slotList.length > 0 &&
                                        <Row>
                                            <Col xl={12} className='text-center'>
                                                <div className='text-dofy fw-semibold'>
                                                    <p>Your availability on that day</p>
                                                </div>
                                            </Col>
                                            <Col xl={12}>
                                                {slotList.filter(it => it.EventDate === slotDate).map((val: IAppointmentSlotModel, idx: number) => (
                                                    <div key={idx} style={{ borderRadius: '10px' }} className={`d-flex justify-content-center p-2 mb-2 cursor-pointer ${slotSession.Id == val.Id ? 'segment-active' : 'segment-passive'}`} onClick={() => { setSlotSession({ StartTime: val.StartTime, EndTime: val.EndTime, Id: val.Id }) }}>
                                                        <div className={`cursor-pointer px-5 text-center`}>
                                                            <p className={`mb-0 py-2 text-nowrap segment-text dofy-admin-font-sm`}>{moment(val.StartTime).format('LT')} TO {moment(val.EndTime).format('LT')}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {!isMobile() ?
                                        <div className='d-flex justify-content-end my-1'>
                                            <CustomButton type={'button'} btnClassName={'btn-soft-dark me-2'} iconClasssName={undefined} name={'Cancel'} onClick={() => navigate(`/agent-ticket-view/${encryptedId}`)} />
                                            {(slotSession.EndTime !== "" && slotSession.StartTime !== "") &&
                                                <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Re-Schedule'} onClick={() => slotHandler()} disabled={isButton} />}
                                        </div> :
                                        <div className='d-flex flex-column my-1 mt-3 gap-2'>
                                            {(slotSession.EndTime !== "" && slotSession.StartTime !== "") &&
                                                <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Re-Schedule'} onClick={() => slotHandler()} disabled={isButton} />}
                                            <CustomButton type={'button'} btnClassName={'btn-soft-dark'} iconClasssName={undefined} name={'Cancel'} onClick={() => navigate(`/agent-ticket-view/${encryptedId}`)} />
                                        </div>}
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </React.Fragment>
    )
}

export default Reschedule
